<script lang="ts">
export default {
  name: 'UIInput',
};
</script>
<script setup lang="ts">

import { computed } from 'vue'
import { cn } from '@/lib/utils'

interface Props {
  class?: string
  type?: string
  modelValue?: string | number
}

const props = withDefaults(defineProps<Props>(), {
  type: 'text'
})

defineEmits<{
  'update:modelValue': [value: string]
}>()

const inputClass = computed(() => 
  cn(
    "tw:flex tw:w-full tw:rounded-md tw:border tw:border-input tw:bg-background tw:px-3 tw:py-2 tw:text-base tw:ring-offset-background tw:file:border-0 tw:file:bg-transparent tw:file:text-sm tw:file:font-medium tw:file:text-foreground tw:placeholder:text-muted-foreground tw:focus-visible:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-offset-2 tw:disabled:cursor-not-allowed tw:disabled:opacity-50 tw:md:text-sm",
    props.class
  )
)
</script>

<template>
  <input
    :type="type"
    :class="inputClass"
    :value="modelValue"
    @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
    v-bind="$attrs"
  />
</template>

